import React from "react";

import RenderWhen from "../../../../../components/RenderWhen";
import { HistoryProps } from "../../../@types/rldynamicanalysis/";
import HistoryTable from "./HistoryTable";
import HistoryTitle from "./HistoryTitle";

const History: React.FC<HistoryProps> = props => (
  <RenderWhen condition={Boolean(props.data)}>
    <HistoryTitle />
    <HistoryTable
      data={props.data}
      hash={props.hash}
      onReportClick={props.onReportClick}
      isStoredReport={props.isStoredReport}
      isNetworkReport={props.isNetworkReport}
    />
  </RenderWhen>
);

export default History;
